// Breeder Profile Definitions
function breederProfileDataQueryDefinition(breederProfileId) {
  return {
    url: `/api/breeder_profiles/${breederProfileId}`,
    enabled: !!breederProfileId
  };
}

// Payment Request Definitions
const paymentRequestCategoryOptionsQueryDefinition = {
  url: '/api/options/payment_request_categories.json',
  defaultValue: {
    data: []
  }
};

function getPaymentRequestQueryDefinition(buyerProfileId, requestId) {
  return {
    method: 'GET',
    url: `/api/buyer_profiles/${buyerProfileId}/payment_requests/${requestId}/edit.json`,
    defaultValue: {
      payment_request: {}
    },
    enabled: !!(buyerProfileId && requestId)
  };
}

function createPaymentRequestMutationDefinition(buyerProfileId) {
  return {
    method: 'POST',
    url: `/api/buyer_profiles/${buyerProfileId}/payment_requests.json`
  };
}

function updatePaymentRequestMutationDefinition(buyerProfileId, requestId) {
  return {
    method: 'PUT',
    url: `/api/buyer_profiles/${buyerProfileId}/payment_requests/${requestId}.json`
  };
}

export {
  breederProfileDataQueryDefinition,
  createPaymentRequestMutationDefinition,
  getPaymentRequestQueryDefinition,
  paymentRequestCategoryOptionsQueryDefinition,
  updatePaymentRequestMutationDefinition
};
